// HeaderDrawer owns the outer drawer. Only nested menus use native inline
// accordions instead of the theme's slide-in submenu handler.
class EcoMobileAccordion extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.addEventListener('keyup', this.onKeyUp, true);
    this.addEventListener('toggle', this.onToggle, true);
    this.drawer = this.closest('header-drawer').querySelector(':scope > details');
    this.drawer.addEventListener('toggle', this.onDrawerToggle);
  }

  disconnectedCallback() {
    this.drawer?.removeEventListener('toggle', this.onDrawerToggle);
    window.removeEventListener('scroll', this.updateDrawerPosition);
    window.removeEventListener('resize', this.updateDrawerPosition);
    window.cancelAnimationFrame(this.positionFrame);
    this.initialized = false;
    this.removeEventListener('keyup', this.onKeyUp, true);
    this.removeEventListener('toggle', this.onToggle, true);
  }

  onDrawerToggle = (event) => {
    if (event.target !== this.drawer) return;
    this.drawer.querySelector('summary').setAttribute('aria-expanded', String(this.drawer.open));
    if (this.drawer.open) {
      this.updateDrawerPosition();
      window.addEventListener('scroll', this.updateDrawerPosition, { passive: true });
      window.addEventListener('resize', this.updateDrawerPosition);
    } else {
      window.removeEventListener('scroll', this.updateDrawerPosition);
      window.removeEventListener('resize', this.updateDrawerPosition);
      window.cancelAnimationFrame(this.positionFrame);
    }
  };

  updateDrawerPosition = () => {
    window.cancelAnimationFrame(this.positionFrame);
    this.positionFrame = window.requestAnimationFrame(() => {
      if (!this.drawer.open) return;
      const headerDrawer = this.closest('header-drawer');
      if (headerDrawer.dataset.breakpoint === 'tablet' && window.matchMedia('(min-width: 990px)').matches) {
        headerDrawer.closeMenuDrawer(new Event('resize'), this.drawer.querySelector('summary'));
        return;
      }
      const header = this.closest('.section-header');
      if (!header) return;
      // The sticky header can move when keyboard focus scrolls the page.
      // Keep the menu and pinned actions within the current viewport.
      const bottom = Math.max(0, header.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty('--header-bottom-position', `${bottom}px`);
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    });
  };

  onKeyUp = (event) => {
    if (event.key !== 'Escape') return;
    const details = event.target.closest('details[open]');
    if (!details || !this.contains(details)) return;

    event.stopPropagation();
    details.open = false;
    details.querySelector('summary').focus();
  };

  onToggle = (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement)) return;

    details.querySelector('summary').setAttribute('aria-expanded', String(details.open));
    if (details.open) {
      // Match the reference: one section and one category open at a time.
      const siblings = details.parentElement.parentElement.children;
      Array.from(siblings).forEach((item) => {
        const sibling = item.querySelector(':scope > details');
        if (sibling && sibling !== details) sibling.open = false;
      });
    } else {
      details.querySelectorAll('details[open]').forEach((child) => {
        child.open = false;
      });
    }
  };
}

if (!customElements.get('eco-mobile-accordion')) {
  customElements.define('eco-mobile-accordion', EcoMobileAccordion);
}
